// NEW: UI_REVAMP
import { Flex, Text } from '@chakra-ui/react';
import GradientText from '../common/GradientText';
import { RECORD_GRADIENTS, RECORD_SHADOWS } from '../../styles/recordUiTokens';
import { ConvertedTime } from '../../utils/Time';
import { currencyFormat } from '../../utils/numberFormat';
import { getTransactionStatusStyle, TRANSACTION_TEXT_COLOR } from './transactionStatusStyles';
import useIsMobileView from '../../hooks/useIsMobileView';

export const TransactionHistoryRow = ({ date, details, debit, credit, refNo, isMobileView }) => {
	const isCredit = Number(credit) > 0;
	const amount = isCredit ? `PHP ${currencyFormat(credit)}` : `-PHP ${currencyFormat(debit)}`;

	return (
		<Flex
			flexDirection='column'
			marginBottom='16px'
			padding='1px'
			borderRadius='8px'
			background={RECORD_GRADIENTS.goldBorder}
			boxShadow={RECORD_SHADOWS.goldCard}
		>
			<Flex
				flexDirection='column'
				borderRadius='7px'
				background={RECORD_GRADIENTS.historyCardSurface}
				padding='10px'
				minHeight='124px'
			>
				<Flex justifyContent='space-between' alignItems='center' height='100%'>
					<Flex flexDirection='column' gap='18px' paddingTop='2px'>
						<TransactionLabel>Transaction Date Time</TransactionLabel>
						<TransactionLabel>Transaction ID</TransactionLabel>
						<TransactionLabel>Transaction Status</TransactionLabel>
						<TransactionLabel>Transaction Amount</TransactionLabel>
					</Flex>
					<Flex flexDirection='column' alignItems='flex-end' gap='16px'>
						<Text
							fontSize={isMobileView ? '14px' : '16px'}
							fontWeight='600'
							lineHeight='100%'
							color='#111111'
						>
							{ConvertedTime({ time: date, format: 'DD/MM/YYYY hh:mm:ss A' })}
						</Text>
						<TransactionIdValue transactionId={refNo} />
						<TransactionStatusPill status={details} />
						<TransactionAmount isCredit={isCredit} amount={amount} />
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
};

const TransactionAmount = ({ isCredit, amount, width, marginTop }) => {
	return (
		<GradientText
			gradient={isCredit ? RECORD_GRADIENTS.greenText : RECORD_GRADIENTS.decreaseAmountGradient}
			width={width}
			marginTop={marginTop}
			fontSize={useIsMobileView() ? '20px' : '22px'}
			fontWeight='700'
			lineHeight='100%'
			textAlign='right'
		>
			{amount}
		</GradientText>
	);
};

const TransactionIdValue = ({ transactionId }) => {
	return (
		<Flex alignItems='center' justifyContent='flex-end' gap='8px' minWidth='0'>
			<Text
				fontSize={useIsMobileView() ? '14px' : '16px'}
				fontWeight='600'
				lineHeight='100%'
				color={TRANSACTION_TEXT_COLOR}
			>
				{transactionId}
			</Text>
		</Flex>
	);
};

const TransactionLabel = ({ children }) => {
	return (
		<Text
			fontSize={useIsMobileView() ? '14px' : '16px'}
			fontWeight='500'
			lineHeight='100%'
			color='#545454'
		>
			{children}
		</Text>
	);
};

const TransactionStatusPill = ({ status }) => {
	const styles = getTransactionStatusStyle(status);

	return (
		<Flex
			alignItems='center'
			justifyContent='center'
			minWidth={styles.minWidth}
			height='27px'
			padding='4px 12px'
			borderRadius='100px'
			background={styles.background}
			color={styles.color}
			fontSize={useIsMobileView() ? '14px' : '16px'}
			fontWeight='600'
			lineHeight='100%'
		>
			{styles.label}
		</Flex>
	);
};
